import http from "e6-base-core/axios/config";

import { e6ModuleBaseDataApi } from "@/config/api";
const { host = "", E6_MS_TMS_E6YUN_BASE_WEB = "" } = e6ModuleBaseDataApi;

export function electronicPage(data) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/electronic/findByPage`,
    method: "post",
    data
  });
}
